const eachYear = (YEARS) => (Array.apply(null, { length: YEARS }).map(Number.call, Number)).map(x => (x + 1));
const nonNegative = x => (x > 0 ? x : 0);
const round2 = x => (parseFloat(x).toFixed(2));
const round = x => (parseInt(x, 10));

const getYears = ({ housePrice, futureHousePricePct, percentLoan, years}) => {
  const futureHousePrice = [ housePrice ];
  const amountProtected = [ housePrice ];
  eachYear(years).forEach(y => {
     const prevHousePrice = futureHousePrice[futureHousePrice.length - 1];
     const housePrice = nonNegative(prevHousePrice * (1 + futureHousePricePct * 0.01));
     futureHousePrice.push(housePrice);
     amountProtected.push(housePrice * (1 - percentLoan));
  });
  return {
    futureHousePrice: round(futureHousePrice[futureHousePrice.length - 1]),
    amountProtected: round(amountProtected[amountProtected.length - 1]),
  };
};

const LtvLevel = {
  Standard: {
    55: 36.8,
    56: 37.6,
    57: 38.8,
    58: 39.8,
    59: 41,
    60: 41.9,
    61: 43,
    62: 43.6,
    63: 44.9,
    64: 46,
    65: 47.2,
    66: 48.5,
    67: 49.5,
    68: 50.3,
    69: 51.5,
    70: 52.4,
    71: 53.5,
    72: 54.4,
    73: 54.5,
    74: 54.5,
    75: 54.5,
    76: 54.5,
    77: 54.5,
    78: 54.5,
    79: 54.5,
    80: 54.5,
    81: 54.5,
    82: 54.5,
    83: 54.5,
    84: 54.5,
    85: 54.5,
    86: 54.5,
    87: 54.5,
    88: 54.5,
    89: 54.5,
    90: 54.5
  }
};

export const guaranteedInheritanceOutput =  (input) => {
  const { years, totalEquityReleased, clientAge, housePrice, futureHousePricePct } = input;
  // const level = qualifyForEnhancedLtv ? 'Mild' : 'Standard';
  const level = 'Standard';
  const maxLoan = round(LtvLevel[level][clientAge] * 0.01 * housePrice);
  const percentLoan = round2(totalEquityReleased / maxLoan);
  
  const offeredNotTaken = round2(1 - parseFloat(percentLoan));
  const percentProtected = Math.min(offeredNotTaken, 
    (input.productChoice === 'prime') ? 1 : 0.5);
  const amountProtectedAtStart = round(percentProtected * housePrice);
  let { amountProtected, futureHousePrice } = getYears({ 
      years, housePrice, futureHousePricePct, 
      percentLoan: 1 - percentProtected });
  return {
     futureHousePrice,
     level,
     maxLoan,
     percentLoan,
     offeredNotTaken,
     amountProtectedAtStart,
     amountProtected,
     percentProtected
  };
};



// WEBPACK FOOTER //
// ./src/services/GuaranteedInheritanceCalc.js